// removed by extract-text-webpack-plugin
module.exports = {"category-links":"styles__category-links___1yULY"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Category/styles.scss
// module id = 321
// module chunks = 0